<template>
  <div class="component_1">
    <v-row class="mt-0 mb-0">
      <v-col cols="12" md="4" class="pt--16">
        <!-- Search Form Start-->
        <v-row class="ma-0" column v-show="false">
          <v-col cols="12" class="pa-0">
            <h2 class="title">{{ $t('component.search_application.fields.application_no') }}</h2>
          </v-col>
          <v-col cols="12" class="pa-0">
            <div class="input_text_type_basic">
              <v-text-field
                placeholder=""
                dense
                outlined
                hide-details
                clearable
                class="ft-size12"
              >
              </v-text-field>
            </div>
          </v-col>
        </v-row>
        <v-row class="ma-0 mt-25" column v-show="false">
          <v-col cols="12" class="pa-0">
            <h2 class="title">{{ $t('component.document_viewer.fields.document_name') }}</h2>
          </v-col>
          <v-col cols="12" class="pa-0">
            <div class="input_text_type_basic">
              <v-text-field
                placeholder=""
                dense
                outlined
                hide-details
                clearable
                class="ft-size12"
              >
              </v-text-field>
            </div>
          </v-col>
        </v-row>
        <v-row class="ma-0 mt-15" v-show="false">
          <v-col cols="12" class="pa-0">
            <v-btn
              dense
              height="40"
              width="100%"
              dark
              color="#a01c2a"
              class="capitalize btn_basic br_none"
            >
              {{ $t('common.button.search') }}
            </v-btn>
          </v-col>
        </v-row>
        <!-- Search Form End-->

        <v-row class="ma-0" style="border: solid 1px; height: 850px; ">
          <v-col cols="12" class="pa-0">
            <v-data-table
              :headers="$getHeaderType1(headerTxt, headers)"
              :items="items"
              hide-default-footer
              class="dviewer"
              disable-pagination
              style="overflow-y : auto;"
              height="848"
              fixed-header
              disable-sort
              :mobile-breakpoint="MobileBreakPoint"
            >
              <template v-slot:item="{ item }">
                <tr @click="fnSetPdfUrl(item)">
                  <td class="text-left">{{ ($vuetify.rtl) ? item.name_ar:item.name_en }}</td>
                  <td>{{item.created_date}}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="8" class="pt-0">

        <div class="none__data__content" v-if="items.length === 0">
          <div class="thumb__bg"></div>
          <p>{{$t('common.message.no_document_list')}}</p>
        </div>
        <div class="none__data__content" v-if="items.length > 0 && !blnViewPdf">
          <div class="thumb__bg"></div>
          <p>{{$t('common.message.click_file_name')}}</p>
        </div>

        <pdf-viewer height="100%" :url="pdfUrl" v-if="items.length > 0 && blnViewPdf"></pdf-viewer>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import PdfViewer from '@/components/layout/PdfViewer.vue'

export default {
  name : 'DocumentViewer',
  components :{
    PdfViewer
  },
  props: {
    items: {
      type: Array
    }
  },
  data () {
    return {
      MobileBreakPoint:0,
      blnViewPdf: false,
      headerTxt : {
        prefix : 'component.document_viewer.fields.',
        txt : [ 'document_name', 'date' ]
      },
      headers: [
        { text: 'Document Name', align: 'center', value: 'file_name' },
        { text: 'Date', align: 'center', value: 'created_date', width: '100'}
      ],
      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',
      pdfUrl: ''

    }
  },
  mounted () {
    this.blnViewPdf = false
  },
  methods: {
    fnSetPdfUrl(item) {
      let file_key = item.file_key
      if (item.pdf_file_path !== '' && item.pdf_file_name !== '') {
        this.pdfUrl = this.downLoadUrl + file_key +'/pdf/'+ item.pdf_file_name
      } else {
        this.pdfUrl = ''
      }
      this.blnViewPdf = true
    }
  },
}

</script>